import React from 'react';
import styled from 'styled-components';
import { applyNoSelect } from '../../mixins';
import { dark02, white } from '../../tokens';
import { Footnote1 } from '../Typography';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Toast/Toast');
export var StyledRoot = /*#__PURE__*/styled(Footnote1).withConfig({
  componentId: "plasma__sc-1y7x3ev-0"
})(["display:inline-flex;align-items:center;padding:0.6875rem 1.25rem;border-radius:1.5rem;background:", ";color:", ";", ";"], dark02, white, applyNoSelect);
var StyledContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-1y7x3ev-1"
})(["display:flex;align-items:center;margin-right:0.5rem;"]);
/**
 * Короткие текстовые подсказки.
 * Вызываются только в текущем запущенном приложении как реакция на выполнение действия пользователем.
 */

export var Toast = function Toast(_ref) {
  var _ref$role = _ref.role,
      role = _ref$role === void 0 ? 'status' : _ref$role,
      text = _ref.text,
      contentLeft = _ref.contentLeft;
  var ariaLive = 'polite';
  var ariaAtomic = false;

  if (role === 'alert') {
    ariaLive = 'assertive';
  } else if (role === 'status') {
    ariaAtomic = true;
  }

  return /*#__PURE__*/React.createElement(StyledRoot, {
    role: role,
    "aria-live": ariaLive,
    "aria-atomic": ariaAtomic
  }, contentLeft && /*#__PURE__*/React.createElement(StyledContent, null, contentLeft), text);
};